import PrintIcon from '@mui/icons-material/Print'
import { Button, ButtonProps, Menu, MenuItem } from '@mui/material'
import { FC, MouseEvent, useContext, useState } from 'react'

import PrintLabel from '../../components/RepairOrder/PrintSticker/PrintLabel'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import usePrintActionNowForMethod from '../../hooks/usePrintActionNowForMethod'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { PrintActionInfoMethodEnum } from '../../sdk'

export const PrintInvoiceButton: FC<ButtonProps> = ({ ...props }) => {
  const { repairOrder } = useContext(RepairOrderContext)

  const { accessToken } = useAccessTokenAndShopId()

  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null)

  const createPrintActionNowForMethod = usePrintActionNowForMethod(
    repairOrder?.entry?.id,
    accessToken
  )

  const openAuthorization = () => {
    createPrintActionNowForMethod(PrintActionInfoMethodEnum.Authorization)
    window.open(`/print.html?id=${repairOrder!.entry!.id!}&type=auth`)
  }
  const openWorkOrder = () => {
    createPrintActionNowForMethod(PrintActionInfoMethodEnum.WorkOrder)
    window.open(`/print.html?id=${repairOrder!.entry!.id!}&type=work`)
  }
  const openInvoiceCustomer = () => {
    createPrintActionNowForMethod(PrintActionInfoMethodEnum.CustomerInvoice)
    window.open(`/print.html?id=${repairOrder!.entry!.id!}&type=customer`)
  }
  const openInvoiceMerchant = () => {
    createPrintActionNowForMethod(PrintActionInfoMethodEnum.MerchantInvoice)
    window.open(`/print.html?id=${repairOrder!.entry!.id!}&type=merchant`)
  }

  return (
    <>
      <Menu
        keepMounted
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null)
            openAuthorization()
          }}
          data-testid="printAuthButton">
          Print Authorization
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null)
            openWorkOrder()
          }}
          data-testid="printRepairOrderButton">
          Print Work Order
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null)
            openInvoiceMerchant()
          }}
          data-testid="printInvoiceButton">
          {'Print Invoice (Merchant Copy)'}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null)
            openInvoiceCustomer()
          }}>
          {'Print Invoice (Customer Copy)'}
        </MenuItem>
        <PrintLabel closeMenu={() => setMenuAnchor(null)} />
      </Menu>

      <Button
        data-testid="PrintButton"
        startIcon={<PrintIcon />}
        onClick={(event: MouseEvent<HTMLElement>) => {
          setMenuAnchor(event.currentTarget)
        }}
        {...props}>
        Print
      </Button>
    </>
  )
}
